import { LocationDto } from "../proxy/skybound/sky-gen1/location";
import { PharmacyLinkDto } from "../proxy/skybound/sky-gen1/pharmacy-link";


export class PharmacyProfile
{
	location: LocationDto;
	pharmacyLink: PharmacyLinkDto;
	notificationCount: number = 0;

	constructor(location: LocationDto, pharmacyLink: PharmacyLinkDto)
	{
		this.location = location;
		this.pharmacyLink = pharmacyLink;
		this.notificationCount = 0;
	}
}